import React, { useContext } from 'react';
import AuthContext from 'store/AuthContext';

function FlightsHeader(props) {
    const { userInfo } = useContext(AuthContext);

    return (
        <div>
            <div><h4>Operator contact person -</h4></div>
            <div className="marginAtTop"> <span className="fontBold userTitle">First Name:</span><span className="userTitle"> {userInfo?.firstName}</span>
                <span className="fontBold userTitle">LastName:</span><span className="userTitle">{userInfo?.lastName}</span>
                <span className="fontBold userTitle">Phone number:</span> <span className="userTitle">{userInfo?.phoneNumber}</span>
                <span className="fontBold userTitle">Email address:</span> <span className="userTitle">{userInfo?.email}</span>
                {userInfo.faxNumber ? (<span className="fontBold userTitle">Fax Number:</span>) : null}
                <span className="userTitle">{userInfo?.faxNumber}</span>
            </div>
        </div>
    )
}

export default FlightsHeader;
